
// for recalculation
export const DEFAULT_PAGE_SIZE = 1000;
export const DEFAULT_RECALCULATE_REELO_PAGE_SIZE = 500;
// for ranks table
export const DEFAULT_PAGE_FETCH_SIZE = 100;
export const DEFAULT_PAGE = 1;